import classNames from 'classnames';
import { ReactNode } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import styles from './Input.module.css';

export type NumericInputProps = {
  className?: string;
  label?: ReactNode;
} & NumericFormatProps;

export const NumericInput = ({ className, label, name, ...props }: NumericInputProps) => {
  return (
    <div className={classNames(styles.root, className)}>
      <label className={styles.label} htmlFor={name}>
        {label}
      </label>
      <NumericFormat className={styles.input} name={name} thousandSeparator="," {...props} />
    </div>
  );
};
